import apiClient from './Api';
const PREFIX = '/user';

const getUsers = () => {
  return apiClient({
    url: `${PREFIX}/all`,
    method: 'GET'
  });
};

const getPhotographerUsers = postData => {
  return apiClient({
    url: `${PREFIX}/allphotographeruser`,
    method: 'GET',
    params: postData
  });
};

const userActiveDeactive = postData => {
  return apiClient({
    url: `${PREFIX}/toggleactivation`,
    method: 'POST',
    data: postData
  });
};

const userUpdateSetting = postData => {
  return apiClient({
    url: `${PREFIX}/updatesetting`,
    method: 'POST',
    data: postData
  });
};

/* // NOT IN USE
const userSetLastDealer = postData => {
  return apiClient({
    url: `${PREFIX}/lastdealer`,
    method: 'POST',
    data: postData
  });
};
const getManagers = () => {
  return apiClient({
    url: `${PREFIX}/managers`,
    method: 'GET'
  });
};
*/

const userSetGuideline = postData => {
  return apiClient({
    url: `${PREFIX}/toggleguideline`,
    method: 'POST',
    data: postData
  });
};

const userSetDmsOverlayToggle = postData => {
  return apiClient({
    url: `${PREFIX}/toggledmsframe`,
    method: 'POST',
    data: postData
  });
};

const getProfiles = postData => {
  return apiClient({
    url: `${PREFIX}/profiles`,
    method: 'POST',
    data: postData
  });
};

const saveProfiles = postData => {
  return apiClient({
    url: `${PREFIX}/saveprofiles`,
    method: 'POST',
    data: postData
  });
};

const removeProfile = postData => {
  return apiClient({
    url: `${PREFIX}/removeprofile`,
    method: 'POST',
    data: postData
  });
};

const getAllProfiles = () => {
  return apiClient({
    url: `${PREFIX}/allprofiles`,
    method: 'GET'
  });
};

const setLogoutHour = postData => {
  return apiClient({
    url: `${PREFIX}/setlogouthour`,
    method: 'POST',
    data: postData
  });
};

const sendReInvite = postData => {
  return apiClient({
    url: `${PREFIX}/reinvite`,
    method: 'POST',
    data: postData
  });
};

const getUnreadNotifications = postData => {
  return apiClient({
    url: `${PREFIX}/getunreadnotif`,
    method: 'POST',
    data: postData
  });
};

const saveUnreadNotification = postData => {
  return apiClient({
    url: `${PREFIX}/saveunreadnotif`,
    method: 'POST',
    data: postData
  });
};

const changeUserPassword = postData => {
  return apiClient({
    url: `${PREFIX}/changeUserPassword`,
    method: 'POST',
    data: postData
  });
};

const getUserDetails = postData => {
  return apiClient({
    url: `${PREFIX}/details`,
    method: 'POST',
    data: postData
  });
};

const getAllPhotographer = () => {
  return apiClient({
    url: `${PREFIX}/photographers`,
    method: 'GET'
  });
};

const getDealerList4Select = () => {
  return apiClient({
    url: `${PREFIX}/seldealer`,
    method: 'GET'
  });
};

const getMyAllDealers = () => {
  return apiClient({
    url: `${PREFIX}/myalldealers`,
    method: 'GET'
  });
};

const getDealerAllList = () => {
  return apiClient({
    url: `${PREFIX}/dealersexceptlt`,
    method: 'GET'
  });
};

const addTeam = postData => {
  return apiClient({
    url: `${PREFIX}/save`,
    method: 'POST',
    data: postData
  });
};

const getUserRolePermissions = () => {
  return apiClient({
    url: `${PREFIX}/getUserRolePermissions`,
    method: 'GET'
  });
};

const UserService = {
  sendReInvite,
  setLogoutHour,
  getUsers,
  getPhotographerUsers,
  userActiveDeactive,
  userUpdateSetting,
  // getManagers,
  // userSetLastDealer,
  userSetGuideline,
  getProfiles,
  saveProfiles,
  removeProfile,
  getAllProfiles,
  getUnreadNotifications,
  saveUnreadNotification,
  changeUserPassword,
  getUserDetails,
  getAllPhotographer,
  getDealerList4Select,
  getMyAllDealers,
  getDealerAllList,
  userSetDmsOverlayToggle,
  addTeam,
  getUserRolePermissions
  // updateSetting
};

export default UserService;
